export const AVERAGE_MONTHLY_SAVINGS = '$110';
export const AVERAGE_RATE_DEDUCTION = '3.34%';
export const AVERAGE_LIFETIME_SAVINGS = '$1,320';
export const MIN_MONTHLY_SAVINGS_FOR_CALLING = 5000; // 50 dollars
export const MIN_APR_SAVINGS_FOR_CALLING = 250; // 2.5%
